import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Vector">
      <path
        d="M16.7 0.5V2.3L2.3 5.9V4.1H0.5V14.9H2.3V13.1L4.1 13.55V15.35C4.1 17.06 5.54 18.5 7.25 18.5C8.96 18.5 10.4 17.06 10.4 15.35V15.17L16.7 16.7V18.5H18.5V0.5H16.7ZM8.6 15.35C8.6 16.07 7.97 16.7 7.25 16.7C6.53 16.7 5.9 16.07 5.9 15.35V14L8.6 14.72V15.35ZM16.7 14.9L2.3 11.3V7.7L16.7 4.1V14.9Z"
        fill="#222A5C"
      />
      <path d="M16.7 14.9L2.3 11.3V7.7L16.7 4.1V14.9Z" fill="#222A5C" />
    </g>
  </svg>,
  "Campaign"
);
